module.exports = __webpack_public_path__ + "static/icone-whats-home-a3a07ce5544cf131eb2a874124a1e941.png";